class estadoMock {
    values = [
        { id: "1", nombre: "ACTIVO" },
        { id: "0", nombre: "INACTIVO" }
    ];
}
export default new estadoMock();
